"use client";

import Link from "next/link";
import SectionHeader from "@/components/ui/section-header";
import UseCasesGrid, { type UseCaseGridItem } from "@/components/sections/shared/use-cases-grid";
import {
  AiVisual,
  BrandVisual,
  MarketVisual,
  PriceVisual,
  ScrapingVisual,
  SecurityVisual,
  SeoVisual,
} from "@/components/sections/shared/use-cases-grid/card-visuals";
import { ROUTES } from "@/lib/constants";

// German clone of mobile-proxies/use-cases — same grid/visuals, translated
// copy. "Genuine mobile networks" (not "carrier") per content policy.

const MOBILE_USE_CASES_DE: UseCaseGridItem[] = [
  {
    id: "web-scraping",
    label: "Web Scraping",
    headline: "Jede öffentliche Website zuverlässig und im großen Stil scrapen.",
    description:
      "Daten in großem Umfang über Premium-Mobile-IPs sammeln. Access Points im Zufallsmodus nutzen für einen frischen Exit bei jeder Verbindung, oder eine sticky Session für eine stabile, bekannte IP halten.",
    href: "/use-cases/web-scraping",
    Visual: ScrapingVisual,
    span: "wide",
  },
  {
    id: "ad-verification",
    label: "Ad Verification",
    headline: "Lokalisierte Anzeigen genau so prüfen, wie Nutzer sie sehen.",
    description:
      "Lokalisierte Anzeigenauslieferung über Premium-Mobile-IPs prüfen, mit Stadt- und Session-Auswahl pro Access Point.",
    href: "/use-cases/ad-verification/",
    Visual: BrandVisual,
  },
  {
    id: "localized-content-testing",
    label: "Localized Content Testing",
    headline: "Jede regionale Variante Ihrer Seiten sehen.",
    description:
      "Genau sehen, wie öffentliche Seiten, Preise und Inhalte für Premium-Mobile-Nutzer in jedem Markt dargestellt werden. Eine Stadt festlegen, eine sticky Session halten oder bei Bedarf rotieren, um jede regionale Variante zu prüfen.",
    href: "/use-cases/localized-testing/",
    Visual: MarketVisual,
    span: "wide",
  },
  {
    id: "seo-testing",
    label: "Regionales SEO-Monitoring",
    headline: "Mobile SERPs aus jeder Stadt verfolgen.",
    description:
      "Mobile SERPs und lokale Rankings über Städte weltweit verfolgen, ohne eine feste Anzahl an Proxies kaufen zu müssen.",
    href: "/use-cases/seo-monitoring",
    Visual: SeoVisual,
  },
  {
    id: "ecommerce-monitoring",
    label: "E-Commerce-Monitoring",
    headline: "Preise und Verfügbarkeit über Regionen hinweg verfolgen.",
    description:
      "Preise, Lagerbestände, Weiterleitungen und mobile Nutzererlebnisse über Regionen hinweg von rotierenden mobilen Exits aus verfolgen.",
    href: "/use-cases/price-monitoring",
    Visual: PriceVisual,
  },
  {
    id: "social-monitoring",
    label: "Social-Media-Monitoring",
    headline: "Öffentliche Social-Media-Daten im großen Stil sammeln.",
    description:
      "Öffentliche Beiträge, Hashtags, Trends und Kommentare über Netzwerke hinweg von Premium-Mobile-IPs sammeln, für Marken- und Marktforschung, mit Rotationskontrolle bei Bedarf.",
    Visual: AiVisual,
  },
  {
    id: "security-testing",
    label: "Cybersecurity-Testing",
    headline: "Premium-Mobile-Nutzer für autorisierte Tests simulieren.",
    description:
      "Premium-Mobile-Nutzer für autorisierte Penetrationstests und Sicherheitsbewertungen aus echten mobilen Netzen simulieren.",
    Visual: SecurityVisual,
  },
];

export default function MobileUseCasesDe() {
  return (
    <section
      id="mobile-use-cases"
      className="py-section border-border border-b"
      aria-labelledby="mobile-use-cases-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <SectionHeader
            eyebrow="Anwendungsfälle"
            id="mobile-use-cases-heading"
            heading="Was Sie mit Mobile Proxies tun können"
            body="Ein Premium-Netzwerk ethisch bezogener mobiler IPs — von umfangreicher Datenerfassung bis zu präziser, standortgenauer Recherche."
          />
        </div>

        <UseCasesGrid items={MOBILE_USE_CASES_DE} />

        <p className="text-muted-foreground mt-8 text-sm leading-relaxed">
          Anderen Anwendungsfall gesucht?{" "}
          <Link
            href={ROUTES.useCases}
            className="text-foreground decoration-foreground/30 hover:decoration-foreground underline underline-offset-4"
          >
            Alle Proxidize-Anwendungsfälle ansehen
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
